import React from "react";
import {Container, Typography, Button, Divider} from "@mui/material"
import Slider from "react-slick";
import styled from "styled-components"
import img1 from "../../Images/calcc.PNG"
import img2 from "../../Images/h2.PNG";
import img3 from "../../Images/h3.PNG";
import img4 from "../../Images/h9.PNG";
import img5 from "../../Images/h6.PNG";
import img6 from "../../Images/h7.PNG";
import img7 from "../../Images/h10.PNG";
import img8 from "../../Images/2.PNG";
import {makeStyles} from "@mui/styles"
import {createTheme} from "@mui/material/styles"

const theme = createTheme()

const useStyles = makeStyles({
  myHead:{
    width: "40%"
  },
  work:{
    height:"auto",
    marginBottom:"4rem"
  },

  text:{
    width:"auto", textAlign:"justify",
    [theme.breakpoints.up("sm")]:{
      width:"85%"
    }
  }
})

const Image = styled.img`
  width: 350px;
  height: 200px;
`



const Work = () =>{
   const classes = useStyles()
  var settings = {
    slidesToShow: 2,
slidesToScroll: 1,
autoplay: true,
autoplaySpeed: 2000,
responsive: [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      dots: true
    }
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 2
    }
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }
  // You can unslick at a given breakpoint now by adding:
  // settings: "unslick"
  // instead of a settings object
]
   };
    return(
      <div className={classes.work}>
        <Container maxWidth="lg" id="portfolio">
             <Typography variant="h4"> My Portfolio </Typography>
             <Divider style={{marginBottom:"2rem"}} />
        <Slider {...settings}>
          <div className={classes.myHead}>
            <Image src={img1} alt="School Management System" />
            <Typography variant="h6" style={{marginTop:"1rem", fontWeight:"bold"}}>Full Stack School Management System</Typography>
            <Typography variant="body1" className={classes.text}> Developed a school management system,
        using React, Material UI, Redux, Express Js, MongoDB, Node Js. It has five (5)
        pages (Front end). This app allows registered users to register, create, update,
        delete, edit students’ scores. This app calculates a total score, total percentage,
        compute grade, total score, average score, automatically generate principal’s
        comments. It works on all devices</Typography>
        <div style={{marginTop:"1.2rem"}}>
         <Button  style={{marginRight:"1.2rem"}} variant="contained" href="http://calcg.netlify.app" target="_blank">View Live</Button>
        <Button variant="contained" href="https://github.com/olawuni50/school_management_system" 
        target="_blank">GitHub</Button>
        </div>
          </div>

          <div>
          <Image src={img2} alt="Memory App" />
          <Typography variant="h6" style={{marginTop:"1rem", fontWeight:"bold"}}>Full Stack Memory App</Typography>
            
            <Typography variant="body1" style={{width:"80%", textAlign:"justify"}}> Developed a memory app, using React,
material UI, Redux, Express Js, MongoDB,Node js. This app allows registered users to register, create, update, delete, edit,
post comments, like and unlike a post, read other user comments, display recommended post, show post details comments. It works on all devices</Typography>
        <div  style={{marginTop:"1.2rem"}}>
         <Button style={{marginRight:"1.2rem"}} variant="contained" href="http://keepi.netlify.app" target="_blank">View Live</Button>
        <Button variant="contained" href="https://github.com/olawuni50/memory-app"
        target="_blank">GitHub</Button>
    
        </div>
        
          </div>

          <div>
          <Image src={img3} alt="School Management System" />
          <Typography variant="h6" style={{marginTop:"1rem", fontWeight:"bold"}}>React UI  School Website</Typography>
            
            <Typography variant="body1" style={{width:"85%", textAlign:"justify"}}> Built school website, with React, react-router-dom, styled-components, react-icons, I
          developed a school website that shows cases all the school info and allows
          students to make school payments.</Typography>
          <div  style={{marginTop:"1.2rem"}}>
         <Button style={{marginRight:"1.2rem"}} variant="contained" href="http://esgs.netlify.app" target="_blank">View Live</Button>
        <Button variant="contained" href="https://github.com/olawuni50/myschool"
        target="_blank">GitHub</Button>
      
        </div>
          </div>

          <div>
          <Image src={img4} alt="School Management System" />
          <Typography variant="h6" style={{marginTop:"1rem", fontWeight:"bold"}}>React Stock Tracker App</Typography>
            
            <Typography variant="body1" style={{width:"90%", textAlign:"justify"}}> Developed a stock tracker by using React
            Hook, this React app computes, total amount, quantity sold, remaining quantity, amount sold, remaining amount, total balance, and inbuilt
            calculator (Only works on Mobile Phones and tablets).</Typography>
        <div  style={{marginTop:"1.2rem"}}>
         <Button style={{marginRight:"1.2rem"}} variant="contained" href="http://stocktrack.netlify.app" target="_blank">View Live</Button>
        <Button variant="contained">GitHub</Button>
    
        </div>
        </div>

        
        <div>
          <Image src={img8} alt="School Management System" />
          <Typography variant="h6" style={{marginTop:"1rem", fontWeight:"bold"}}>React UI Financial Institution Website</Typography>
            
            <Typography variant="body1">Developed a mobile-friendly banking website built using React js, react smooth
            scroll, styled-components, react icons.</Typography>

          <div  style={{marginTop:"1.2rem"}}>
         <Button style={{marginRight:"1.2rem"}} variant="contained" href="http://idevl.netlify.app" target="_blank">View Live</Button>
        <Button variant="contained" href="https://github.com/olawuni50/iDev" target="_blank">GitHub</Button>
      
        </div>
          </div>

          <div>
          <Image src={img5} alt="School Management System" />
          <Typography variant="h6" style={{marginTop:"1rem", fontWeight:"bold"}}>HTML/CSS3 Website</Typography>
            
            <Typography variant="body1" style={{width:"90%", textAlign:"justify"}}>Developed a hosting website using
HTML5 and CSS3</Typography>
        <div  style={{marginTop:"1.2rem"}}>
         <Button style={{marginRight:"1.2rem"}} variant="contained" href="http://olukunlehtml.netlify.app" target="_blank">View Live</Button>
        <Button href="https://github.com/olawuni50/loruki-website" target="_blank" variant="contained">GitHub</Button>
    
        </div>
        
          </div>

          <div>
          <Image src={img7} alt="School Management System" />
          <Typography variant="h6" style={{marginTop:"1rem", fontWeight:"bold"}}>React UI Technology Website</Typography>
            
            <Typography variant="body1"> Developed a mobile-friendly technology website using React, React smooth scroll, styled-components, react icons.</Typography>

          <div  style={{marginTop:"1.2rem"}}>
         <Button style={{marginRight:"1.2rem"}} variant="contained" href="http://reacttech.netlify.app" target="_blank">View Live</Button>
        <Button variant="contained" href="https://github.com/olawuni50/reactech" target="_blank">GitHub</Button>
      
        </div>
          </div>

          <div>
          <Image src={img6} alt="School Management System" />
          <Typography variant="h6" style={{marginTop:"1rem", fontWeight:"bold"}}>React UI  Billing Website</Typography>
            
            <Typography variant="body1"> Developed a responsive website that showcase React templates using React,
              react-smooth-scroll, styled-components, react icons.</Typography>
          <div  style={{marginTop:"1.2rem"}}>
         <Button style={{marginRight:"1.2rem"}} variant="contained" href="http://ultratech.netlify.app" target="_blank">View Live</Button>
        <Button variant="contained" href="https://github.com/olawuni50/ultratech">GitHub</Button>
      
        </div>
          </div>

        </Slider>
            </Container>
            </div>

    )
}

export default Work